import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Box,
  CircularProgress,
  Typography,
  Alert,
} from '@mui/material';
import NumbersIcon from '@mui/icons-material/Numbers';

interface BulkDepartmentNoUpdateDialogProps {
  open: boolean;
  loading: boolean;
  selectedCount: number;
  departmentNo: number;
  onDepartmentNoChange: (value: number) => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export const BulkDepartmentNoUpdateDialog: React.FC<BulkDepartmentNoUpdateDialogProps> = ({
  open,
  loading,
  selectedCount,
  departmentNo,
  onDepartmentNoChange,
  onConfirm,
  onCancel,
}) => {
  const isValidDepartmentNo = departmentNo >= 1 && departmentNo <= 100;

  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <NumbersIcon color="info" />
        Toplu ÖKC (Departman No) Güncelleme
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 3 }}>
          <strong>{selectedCount}</strong> ürünün ÖKC (Departman Numarası) değerini güncellemek üzeresiniz.
        </DialogContentText>
        
        <Alert severity="info" sx={{ mb: 2 }}>
          ÖKC departman numarası yazarkasa entegrasyonu için kullanılır. 
          Geçerli değer aralığı: <strong>1-100</strong>
        </Alert>
        
        <Box sx={{ mt: 2 }}>
          <TextField
            fullWidth
            type="number"
            label="Departman Numarası (ÖKC)"
            value={departmentNo}
            onChange={(e) => onDepartmentNoChange(Number(e.target.value))}
            disabled={loading}
            inputProps={{ min: 1, max: 100, step: 1 }}
            error={departmentNo !== 0 && !isValidDepartmentNo}
            helperText={
              departmentNo !== 0 && !isValidDepartmentNo 
                ? 'Departman numarası 1-100 arasında olmalıdır' 
                : 'Yazarkasa için departman numarası (1-100)'
            }
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          İptal
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="info"
          disabled={loading || !isValidDepartmentNo}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? 'Güncelleniyor...' : `${selectedCount} Ürünü Güncelle`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkDepartmentNoUpdateDialog;

